import React from 'react';
import styled, { css } from 'styled-components';

const MainLayoutContainer = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100%;
  margin: auto 0;
  z-index: 100;
  position: relative;

  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => {
  return theme.name !== 'blank' && css`
    height: ${theme.mainLayout.container.height || '100%'};
    width: ${theme.mainLayout.container.width || '100%'};
    margin: ${theme.mainLayout.container.margin || 'auto 0'};
    display: ${theme.mainLayout.container.display || 'flex'};
    flex-flow: ${theme.mainLayout.container.flexFlow || 'column'};
  `;
} }
`;

export const MainLayout = (props) => <MainLayoutContainer {...props} />;

const TopContentContainer = styled.div`
  top: 0;
  padding: 0 2.8rem;
  display: flex;
  align-items: left;
  justify-content: space-between;

  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    padding: ${theme.mainLayout.topContent.padding || '0 2.8rem'};
    border-bottom: ${theme.mainLayout.topContent.borderBottom || '0.1rem solid #ced4da'};
  `}
`;

export const TopContent = (props) => <TopContentContainer {...props} />;

const MainContentContainer = styled.div`
  flex-grow: 1;
  position: relative;
  overflow: hidden;

  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    position: ${theme.mainLayout.mainContent.position || 'relative'};
    overflow: ${theme.mainLayout.mainContent.overflow || 'hidden'};
  `}
`;

export const MainContent = (props) => <MainContentContainer {...props} />;

export const Content = styled.div`
  padding: 2.8rem;
  height: 100%;
  flex-grow: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    padding: ${theme.mainLayout.content.padding || '2.8rem'};
    height: ${theme.mainLayout.content.height || '100%'};
  `}
`;

export const Box = styled.div`
  flex-wrap: wrap;
  align-items: stretch;
  height: 100%;
  padding-bottom: 80px;

  ${(props) => props.outlined && 'outline: 1px solid red;'}
  ${(props) => props.inline && 'display: inline-block;'}
  ${(props) => props.flex && 'display: flex;'}
  ${(props) => props.column && 'flex-direction: column;'}
  ${(props) => props.alignItems && `flex-direction: ${props.alignItems};`}
  ${(props) => props.expanded && 'flex: 1;'}
  ${(props) => props.width && `width: ${props.width};`}
  ${(props) => props.height && `height: ${props.height};`}
  ${(props) => props.maxHeight && `max-height: ${props.maxHeight};`}
  ${(props) => props.mt && `margin-top: ${props.mt};`}
`;

export const Expanded = styled.div`
  flex: 1;
`;

export default MainLayout;
